/**
 * RevenuePerMemberTrendChart — NOT_CONNECTED
 *
 * Revenue data requires Core Banking integration.
 * Renders DataSourceNotConnected placeholder.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const RevenuePerMemberTrendChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.core_banking}
      metricName="Revenue per Member Trend"
    />
  );
};

export default RevenuePerMemberTrendChart;